var SearchAddressControl = (function() {
  'use strict';

  var mapGL = null;
  var bounds = null;
  var marker = null;

  var searchForm = null;
  var searchButton = null;
  var addressInput = null;
  var addressInputHidden = null;

  var autocompleteAddress = null;

  var getPopupContent = function(address) {
    var popupContent = '<div class="map-popup">';
    popupContent += '<div class="map-popup__address">' + address + '</div>';
    popupContent += '</div>';

    return popupContent;
  };

  var gotoAddress = function(coords) {
    mapGL.getMapObject().flyTo({center: [coords.lng, coords.lat], zoom: 15});
    marker.getElement().setAttribute('data-lng', coords.lng);
    marker.getElement().setAttribute('data-lat', coords.lat);
    marker.getElement().setAttribute('data-address', coords.libelle);
    marker.setLngLat([coords.lng, coords.lat]).addTo(mapGL.getMapObject());
  };

  var submitSearch = function() {
    var submittedAddress = addressInput.value;
    Geocoder.geocode(submittedAddress, function(predictions) {
      if (predictions) {
        if (Utils.inBounds({lng: predictions.lng, lat: predictions.lat}, bounds)) {
          let coordsToZoom = {
            'libelle': submittedAddress,
            'lng': predictions.lng,
            'lat': predictions.lat
          };
          autocompleteAddress.setCoordsToZoom(coordsToZoom);
          gotoAddress(coordsToZoom);
          addressInputHidden.value = predictions.lat + ',' + predictions.lng;
        }
      }
    });
  };

  var open = function() {
    $('#address-map-control').removeClass('is-hidden');

    if (addressInput.value !== '' && addressInputHidden.value !== '') {
      let coords = addressInputHidden.value.split(',');
      let coordsToZoom = {
        'libelle': addressInput.value,
        'lng': coords[1],
        'lat': coords[0]
      };
      autocompleteAddress.setCoordsToZoom(coordsToZoom);
      gotoAddress(coordsToZoom);
    } else {
      autocompleteAddress.setCoordsToZoom(null);
    }
  };

  var close = function() {
    $('#address-map-control').addClass('is-hidden');
    marker.remove();
  };

  return {
    open: open,
    close: close,
    init: function(map) {
      mapGL = map;

      searchForm = document.getElementById('search-address-form');
      addressInput = document.getElementById('js-map-address');
      addressInputHidden = document.getElementById('js-map-address-hidden');
      searchButton = document.getElementById('js-map-search');

      bounds = mapGL.getMapObject().getMaxBounds();

      autocompleteAddress = new AutocompleteAddress(addressInput.id, "autocompleteResults", mapGL.getMapObject().getMaxBounds());

      var el = document.createElement('div');
      el.className = 'icon-map-address';

      marker = new maplibregl.Marker({element: el});

      var markerElement = marker.getElement();
      markerElement.addEventListener('mouseenter', function(e){
        mapGL.tooltip.setHTML(getPopupContent(marker.getElement().getAttribute('data-address')))
          .setLngLat([marker.getElement().getAttribute('data-lng'), marker.getElement().getAttribute('data-lat')])
          .addTo(mapGL.getMapObject());
      });

      markerElement.addEventListener('mouseleave', () => mapGL.tooltip.remove());

      searchForm.addEventListener('submit', function(e) {
        e.preventDefault();
        submitSearch();
      });

      searchButton.addEventListener('click', function(e) {
        submitSearch();
      });

      document.addEventListener('gotoAddress', function(e) {
        submitSearch();
      });
    }
  };

}());
